import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
    'zh_tw': {
        privacy_policy: '隱私權政策',

        oops: '糟糕…',
        api_error: '指令發生錯誤: {code} {status}',
        permission_denied: '權限不足或已失效, 請重新整理或重新登入.',
        report_error: '回報錯誤',
        report_error_submitted: '感謝您! 這個問題已經被回報, 我們將儘快處理.',

        auth_init_error: '無法初始化身份認證服務',
        auth_error: '身份認證錯誤',
        sign_in: '登入',
        sign_in_with_google: '使用 Google 帳號登入',
        sign_in_with_line: '使用 LINE 帳號登入',
        signing_in: '正在登入…',
        sign_out: '登出 {account}…',

        about: '關於我們',
        re_login: '重新登入',
        close: '關閉',

        copy: '複製',

        view_details: '了解更多 »',
        coming_soon: '敬請期待…',

        elevation_api: '台灣高程 API',
        elevation_api_summary: '以內政部20公尺網格DTM開放資料為基礎, 提供 OpenAPI 3.0 服務介面並開源核心元件, 可查詢單點或多點地理座標所對應的高程資料.',
    },
    'en': {
        site_name: 'Outdoor Safety Lab',
        copyright: '© 2022 Outdoor Safety Lab',
        privacy_policy: 'Privacy Policy',
        about: 'About',

        sign_in: 'Sign In',
        sign_in_with_google: 'Sign In with Google',
    },
}

export const i18n = new VueI18n({
    locale: 'zh_tw',
    fallbackLocale: 'en',
    messages,
})
